export default "__VITE_ASSET__18de2d67__"